/**
 * Shared Firestore parsing helpers used by property repository and query service.
 */
export function parseDate(dateValue: unknown): Date | null {
  if (!dateValue) return null;

  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? null : dateValue;
  }

  if (typeof dateValue === 'object' && dateValue !== null && 'toDate' in dateValue) {
    const d = (dateValue as { toDate: () => Date }).toDate;
    if (typeof d === 'function') return d.call(dateValue);
  }

  if (typeof dateValue === 'string') {
    const parsed = new Date(dateValue);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof dateValue === 'number') {
    const parsed = new Date(dateValue);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
}
